export class MailingListToUserEntity {
    id;
    mailingListId;
    userId;

    constructor(id, mailingListId, userId) {
        this.id = id;
        this.mailingListId = mailingListId;
        this.userId = userId;
    }
}